import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl, imageUrl } from "../Baseurl";
import { Link } from "react-router-dom";
import Swal from 'sweetalert2';
import VisitorNavbar from "../component/VisitorNavbar";
import VisitorSidebar from "../component/VisitorSidebar";
import { Accordion, Card, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const MyInquiry = () => {
  const [loading, setLoading] = useState(true);
  const [inquiries, setInquiries] = useState([]);
  const [expandedRows, setExpandedRows] = useState([]); // track expanded rows
  const cust_id = localStorage.getItem("cust_id");  

  useEffect(() => {
    if (!cust_id) {
      Swal.fire("Error", "Customer ID is missing!", "error");
      return;
    }

    const fetchInquiries = async () => {
      try {
        const response = await axios.get(`${baseurl}FetchCartInquiry/${cust_id}`);
        setInquiries(response.data.cartItems || []);
      } catch (error) {
        console.error("Error fetching inquiries:", error);
        Swal.fire("Error", "Failed to load inquiries", "error");
      } finally {
        setLoading(false);
      }
    };

    fetchInquiries();
  }, [cust_id]);

  const toggleRow = (cart_id) => {
    setExpandedRows(prev => 
      prev.includes(cart_id) ? prev.filter(id => id !== cart_id) : [...prev, cart_id]
    );
  };

  return (
    <>
      <VisitorNavbar />
      <div>
        <section className="mb-5">
          <div className="container-fluid">
            <div className="row my-3 g-2 justify-content-center">
              <div className="col-md-2 hide-on-mobile">
                <VisitorSidebar />
              </div>

              <div className="col-md-10">
                <div className="reviewcls text-start">
                  <h4 className="selh1">My Inquiry</h4>
                  <p className="payttl">
                    Please find your inquiry details below.
                  </p>
                  <hr />

                  {loading ? (
                    <p>Loading inquiries...</p>
                  ) : inquiries.length === 0 ? (
                    <p>No inquiries found.</p>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <thead className="table-dark">
                          <tr>
                            <th>#</th>
                            <th colSpan={2}>Title</th>
                            <th>Status</th>
                            <th>Requested At</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {inquiries.map((item, index) => (
                            <React.Fragment key={item.cart_id}>
                              <tr>
                                <td>{index + 1}</td>
                                <td>
                                  <img 
                                    src={`${imageUrl}listing/${item.image}`} 
                                    alt={item.title} 
                                    width="50" height="50" className="me-2 rounded" 
                                  />
                                </td>
                                <td>{item.title}</td>
                                <td>
                                  <span className={`text-capitalize badge ${item.cart_status === "active" ? "bg-success" : "bg-secondary"}`}>
                                    {item.cart_status}
                                  </span>
                                </td>
                                <td>{new Date(item.added_at).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "2-digit" })}</td>
                                <td>
                                  <Button variant="primary" size="sm" onClick={() => toggleRow(item.cart_id)}>
                                    {expandedRows.includes(item.cart_id) ? "Hide Details" : "View Details"}
                                  </Button>
                                </td>
                              </tr>

                              {expandedRows.includes(item.cart_id) && (
                                <tr>
                                  <td colSpan={6}>
                                    <Card className="p-2">
                                 
                                      <Accordion>
                                        {item.seller_responses && item.seller_responses.length > 0 ? (
                                          item.seller_responses.map((res, idx) => (
                                            <Accordion.Item eventKey={idx.toString()} key={idx}>
                                              <Accordion.Header className="p-0 m-0"><span className="acspn">{`Sent at: ${new Date(res.sent_at).toLocaleDateString()}`}</span></Accordion.Header>
                                              <Accordion.Body><span className="px-3">{res.message}</span></Accordion.Body>
                                            </Accordion.Item>
                                          ))
                                        ) : (
                                          <p>No email responses yet.</p>
                                        )}
                                      </Accordion>
                                    </Card>
                                  </td>
                                </tr>
                              )}
                            </React.Fragment>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default MyInquiry;
